import { Accordion } from '../accordion';
import { TDetailsProps } from 'types';

export const Includes = (props: TDetailsProps) => {
  return (
    <div>
      <div className="flex flex-col gap-4 px-8 pb-8">
        <div className="flex flex-col gap-2">
          <div className="text-lg font-bold">{props?.includedTitle}</div>
          <div className="text-lg font-semibold text-neutralPlus">{props?.includedSub}</div>
        </div>
        <p className="text-sm leading-[160%]">{props?.includedDesc}</p>
        <span className="text-lg font-bold">{props?.includedPackageTitle ?? 'Hva inkluderer pakken'}</span>
      </div>
      <div className="px-4">
        {props?.included?.map((item, index) => {
          const isOdd = index % 2 === 1;
          const bgClass = isOdd ? 'bg-lightGrey! hover:bg-lightGrey!' : 'hover:bg-transparent!';

          return (
            <Accordion
              key={index}
              primaryLabel={item?.title}
              className="border-none outline-none"
              triggerClassName={bgClass}
              contentClassName={bgClass}
            >
              <p className="py-2 text-xs font-bold leading-[160%]">{item?.description}</p>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};
